export default __webpack_public_path__ + "static/media/MiniTape_SideA_07_Interview-Fabian-Schwander.f9ead749.mp3";